export default __webpack_public_path__ + "static/austria-mark-fin-2b95fea27e8e3d40a3be8c7e33889f40.jpg";